export default function reservebarSidebar() {
    const root = document.querySelector('[data-reservebar-sidebar]');
    if (!root)
        return;
    const content = root.querySelector('[data-reservebar-content]');
    const template = root.querySelector('[data-reservebar-template]');
    const closeEls = root.querySelectorAll('[data-reservebar-close]');
    if (!content || !template)
        return;
    const clientId = root.getAttribute('data-reservebar-client-id') || '';
    let isOpen = false;
    let currentGrouping = '';
    const UNAVAILABLE_ALERT_SELECTOR = '.liquid-unavailable-location-alert';
    const MLS_GROUPING_IDS = new Set([
        '2563695',
        '2563940',
        '2563941',
        '2563942',
        '2563939',
    ]);
    const MLS_UNAVAILABLE_ALERT_COPY = `This specific bottle is only available for delivery within the MLS club's home state. To continue, please enter an address within that state.
<br><br>
Not in the area? You can still shop our Jameson x MLS Limited Edition Design (shipping to 35 states) <a href="/en-us/our-whiskey/jameson-limited-edition-mls" target="_blank">online</a> or in <a href="/en-us/buy-jameson/?wtb-sku=JamesonMLS" target="_blank">store</a>.`;
    const DISTILLERS_BATCH_UNAVAILABLE_ALERT_COPY = `We're sorry, Jameson Distiller's Batch is not currently available for delivery to your address.`;
    const DEFAULT_UNAVAILABLE_ALERT_COPY = `We're sorry, this product is not currently available for delivery to your address. Click <a href="/en-us/buy-jameson/">here</a> to find this product in a store near you.`;
    function getUnavailableAlertCopy(grouping) {
        if (MLS_GROUPING_IDS.has(grouping))
            return MLS_UNAVAILABLE_ALERT_COPY;
        if (grouping === '2576646')
            return DISTILLERS_BATCH_UNAVAILABLE_ALERT_COPY;
        return DEFAULT_UNAVAILABLE_ALERT_COPY;
    }
    function getGroupingFromAlert(alert) {
        const groupingEl = alert.closest('[liquid-id^="GROUPING-"]');
        if (!groupingEl)
            return currentGrouping;
        const liquidId = groupingEl.getAttribute('liquid-id') || '';
        const match = liquidId.match(/^GROUPING-(\d+)$/);
        return (match === null || match === void 0 ? void 0 : match[1]) || currentGrouping;
    }
    function applyUnavailableAlertCopy(rootEl = document) {
        const alerts = [];
        if (rootEl instanceof Element && rootEl.matches(UNAVAILABLE_ALERT_SELECTOR)) {
            alerts.push(rootEl);
        }
        else {
            alerts.push(...Array.from(rootEl.querySelectorAll(UNAVAILABLE_ALERT_SELECTOR)));
        }
        for (const alert of alerts) {
            if (alert.dataset.rbCustomCopy)
                continue;
            alert.innerHTML = getUnavailableAlertCopy(getGroupingFromAlert(alert));
            alert.dataset.rbCustomCopy = 'true';
        }
    }
    let unavailableObserverStarted = false;
    function startUnavailableAlertObserver() {
        if (unavailableObserverStarted)
            return;
        unavailableObserverStarted = true;
        applyUnavailableAlertCopy();
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                mutation.addedNodes.forEach((node) => {
                    var _a, _b, _c, _d;
                    if (node.nodeType !== 1)
                        return;
                    const el = node;
                    if ((_b = (_a = el).matches) === null || _b === void 0 ? void 0 : _b.call(_a, UNAVAILABLE_ALERT_SELECTOR)) {
                        applyUnavailableAlertCopy(el);
                        return;
                    }
                    if ((_d = (_c = el).querySelector) === null || _d === void 0 ? void 0 : _d.call(_c, UNAVAILABLE_ALERT_SELECTOR)) {
                        applyUnavailableAlertCopy(el);
                    }
                });
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
    function reInitLiquidSDK() {
        const sdk = globalThis.liquidSDK;
        if (!sdk || typeof sdk.init !== 'function' || !clientId)
            return;
        try {
            sdk.init({ clientId, includeMerchandise: false });
        }
        catch (_a) {
            // ignore
        }
    }
    const open = (grouping) => {
        currentGrouping = grouping;
        const html = template.innerHTML.split('__GROUPING__').join(grouping);
        content.innerHTML = html;
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        document.body.classList.add('reservebar-sidebar-open');
        isOpen = true;
        startUnavailableAlertObserver();
        applyUnavailableAlertCopy(content);
        // Ensure Liquid SDK hydrates tags inserted at click-time.
        reInitLiquidSDK();
    };
    const close = () => {
        if (!isOpen)
            return;
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('reservebar-sidebar-open');
        content.innerHTML = '';
        currentGrouping = '';
        isOpen = false;
    };
    for (const el of closeEls) {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            close();
        });
    }
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape')
            close();
    });
    document.addEventListener('click', (e) => {
        const target = e.target;
        const trigger = target === null || target === void 0 ? void 0 : target.closest('[data-reservebar-open][data-reservebar-grouping]');
        if (!trigger)
            return;
        const grouping = trigger.getAttribute('data-reservebar-grouping') || '';
        if (!grouping)
            return;
        e.preventDefault();
        open(grouping);
    });
}
